import React from 'react';
import { connect } from "react-redux";
import * as actionsDuck from '../../store/ducks/actions.duck';
import PortletSpinner from '../../partials/layout/PortletSpinner';
import ActionsGrid from './Actions/ActionsGrid';
import * as actionMailSubscriptionCrud from "../../crud/actionMailSubscription.crud";


class ActionsDashboard extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loadingSubscription: window.location.hash === "#subscription",
      activeMailSubscription: null,
    }
  }

  componentDidMount() {
    // removeAsideMenu();
    // minimizeAsideMenu();
    this.props.loadActions();
    if (window.location.hash === "#subscription") {
      this.fetchActiveMailSubscription();
    }
  }
  fetchActiveMailSubscription = async () => {
    try {
      const { data: result } = await actionMailSubscriptionCrud.getActiveSubscription();
      this.setState({ activeMailSubscription: result, loadingSubscription: false });
    } catch (err) {
      this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
      this.setState({ loadingSubscription: false });
    }
  }

  render() {
    if (!this.props.actionsList || this.state.loadingSubscription) {
      return (<PortletSpinner />);
    }
    return (
      <>
        <ActionsGrid activeMailSubscription={this.state.activeMailSubscription} />
      </>
    );
  }
}

const mapStateToProps = store => ({
  actionsList: store.actions.actionsList
});

const mapDispatchToProps = {
  loadActions: actionsDuck.actions.fetchStart
}

export default connect(mapStateToProps, mapDispatchToProps)(ActionsDashboard);